import type { ListingLabel as ListingLabelEnum } from '@bb/automaton';
import axios from 'axios';

export type ListingLabel = keyof typeof ListingLabelEnum;

export type ListingLabelOverride = {
  label: ListingLabel;
  override: string;
  hideLabel: boolean;
}[];

const getListingLabelOverride = async (onboardingPortalId?: string) => {
  if (!onboardingPortalId) return [];

  const url = `/onboarding-portal/${onboardingPortalId}/listing-label-override`;

  const { data } = await axios.get<ListingLabelOverride>(url);

  return data;
};

export default getListingLabelOverride;
